import React, { FC, useState, useMemo } from "react";
import SearchInput from "./SearchInput";
import NoSearchResults from "./NoSearchResults";
import styles from "../../../styles/B2C/StepLayout.module.scss";
import gridStyles from "../../../styles/B2C/OptionGrid.module.scss";
import { useWizardOptions } from "../../../context/WizardOptionsContext";
import { WizardOption } from "../../../constants/onboardingFallbacks";

interface DegreeStepProps {
  selected: string;
  onSelect: (degree: string) => void;
}

const DegreeStep: FC<DegreeStepProps> = ({ selected, onSelect }) => {
  const { degreeLevels } = useWizardOptions();
  const options = useMemo(() => degreeLevels ?? [], [degreeLevels]);

  const [search, setSearch] = useState("");

  const filteredOptions = useMemo(() => {
    if (!search.trim()) return options;
    return options.filter((degree) =>
      degree.label.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, options]);

  const handleSelect = (degree: string) => {
    onSelect(degree);
  };

  return (
    <div className={styles.stepContent}>
      <SearchInput value={search} onChange={setSearch} placeholder="Search..." />
      {search.trim() !== "" && filteredOptions.length === 0 ? (
        <NoSearchResults />
      ) : (
        <div className={gridStyles.degreeGrid}>
          {filteredOptions.map((degree: WizardOption) => {
            return (
              <button
                key={degree.label}
                type="button"
                title={degree.label}
                className={`${gridStyles.optionItem} ${
                  selected === degree.label ? gridStyles.selected : ""
                }`}
                onClick={() => handleSelect(degree.label)}
              >
                <span className={gridStyles.optionLabel}>{degree.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DegreeStep;
